export default function GHLForm() {
  return (
    <div
      data-testid="ghl-form-container"
      className="w-full bg-white rounded-md overflow-hidden shadow-2xl"
    >
      <iframe
        src="https://api.leadconnectorhq.com/widget/form/s06k9211gNU6ecV4dikP"
        style={{ width: "100%", height: "100%", minHeight: "500px", border: "none", borderRadius: "4px" }}
        id="inline-s06k9211gNU6ecV4dikP"
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Contact Us"
        data-height="undefined"
        data-layout-iframe-id="inline-s06k9211gNU6ecV4dikP"
        data-form-id="s06k9211gNU6ecV4dikP"
        data-cookie-consent="true"
        data-cookie-consent-provider="auto"
        title="Contact Us"
      />
    </div>
  );
}
